module.exports = __webpack_public_path__ + "static/hot-logo-3671869652516288c76bb1d1b410d26e.png";